<template>
  <div class="table">
    <div class="container">
      <div class="handle-box">
        <el-form label-width="120px" ref="queryCondition" :model="queryCondition" label-position="right" class="searchForm">
          <el-row>
            <el-col :span="24">
              <el-row :gutter="20">
                <el-col :span="6">
                  <el-form-item label="单据编号" prop="applyNo">
                    <el-input class="handle-input" v-model="queryCondition.applyNo" clearable placeholder="请输入单据编号" style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="主题" prop="subject">
                    <el-input class="handle-input" v-model="queryCondition.subject" clearable placeholder="请输入主题" style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="类型" prop="applyType">
                    <el-select class="handle-input" v-model="queryCondition.applyType" placeholder="类型" clearable style="width:100%">
                      <el-option :label="$t('common.all')" value></el-option>
                      <el-option :key="index" v-for="(item,index) in applyTypeOptions" :label="item | inputChoiceI18n" :value="item.code"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="入围供应商" prop="supplierCode">
                    <el-input class="handle-input" suffix-icon="el-icon-search" @click.native="showSelSupplierDialog=true;SupplierNameDialogReset = true" clearable v-model="queryCondition.supplierCode" @clear="clearSupplierName" style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <el-collapse-transition>
              <el-col :span="24" v-if="isShow">
                <el-row :gutter="20">
                  <el-col :span="6">
                    <el-form-item label="申请单状态" prop="status">
                      <el-select class="handle-input" v-model="queryCondition.status" placeholder="申请单状态" clearable style="width:100%">
                        <el-option :label="$t('common.all')" value="all"></el-option>
                        <el-option :key="index" v-for="(item,index) in statusListOptions" :label="item | inputChoiceI18n" :value="item.code"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="报价状态" prop="quotationStatus">
                      <el-select class="handle-input" v-model="queryCondition.quotationStatus" placeholder="报价状态" clearable style="width:100%">
                        <el-option :label="$t('common.all')" value></el-option>
                        <el-option :key="index" v-for="(item,index) in quotationStatusOptions" :label="item | inputChoiceI18n" :value="item.code"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="创建人" prop="name">
                      <el-input class="handle-input" v-model="queryCondition.name" clearable placeholder="请输入创建人" style="width:100%"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="报价确认申请单" prop="sourcingNo">
                      <el-input class="handle-input" v-model="queryCondition.sourcingNo" clearable placeholder="请输入报价确认申请单" style="width:100%"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="6">
                    <el-form-item label="报价确认状态" prop="sourcingStatus">
                      <IcSelect v-model="queryCondition.sourcingStatus" table="TT_SOURCING_HEAD" field="STATUS" clearable :allValues="true" style="width:100%"></IcSelect>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="创建日期(从)" prop="createDate">
                      <el-date-picker v-model="queryCondition.createDate" type="date" placeholder="选择日期" value-format="yyyy-MM-dd" style="width:100%"></el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="创建日期(至)" prop="createEndDate">
                      <el-date-picker value-format="yyyy-MM-dd" v-model="queryCondition.createEndDate" type="date" :placeholder="$t('common.selDate')" style="width:100%"></el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="8位码" prop="eightBitCodesStr">
                      <el-input v-model="queryCondition.eightBitCodesStr" type="textarea" :autosize="{ minRows: 2, maxRows: 4}" clearable class="handle-input" placeholder="请输入8位码" style="width:100%"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
            </el-collapse-transition>
          </el-row>
          <el-row type="flex" justify="center" align="middle">
            <el-button size="mini" @click="queryData(1)" type="primary">{{$t('common.search')}}</el-button>
            <el-button size="mini" @click="restQueryFormThis" type="primary">重置</el-button>
            <span class="arrowDown" @click="isShow=!isShow">{{isShow?'收缩':'展开'}}<i :class="isShow?'el-icon-arrow-up iconBtn':'el-icon-arrow-down iconBtn'"></i></span>
          </el-row>
        </el-form>
      </div>
      <div class="action-btn-row">
        <el-button size="mini" class="btn" type="primary" v-acl="ProApplyInfoCreateNew" @click="addNewApply(-1)">新增</el-button>
        <el-button size="mini" class="btn" type="danger" v-acl="proApplyDeleteApply" @click="delApply()">{{$t('common.del')}}</el-button>
        <el-button size="mini" class="btn" type="primary" v-acl="proApplyCloseApply" @click="closeApply()">作废</el-button>
      </div>
      <el-table :data="tableData" border max-height="470" highlight-current-row>
        <el-table-column align="center" fixed width="56" :label="$t('common.select')">
          <template slot-scope="scope">
            <el-radio :disabled="scope.row.status=='3'" v-model="radioVal" @change.native="getSelectRow(scope.row)" :label="scope.row.ttQuotationApplyId">&nbsp;</el-radio>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip fixed sortable prop="applyNo" label="单据编号" min-width="100px">
          <template slot-scope="scope">
            <el-link type="primary" @click="openQuotationApplyDetail(scope.row)">{{scope.row.applyNo}}</el-link>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="subject" label="主题" min-width="140px"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="supplierNames" label="入围供应商" min-width="150px"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="name" label="创建人" min-width="160px"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="createDate" label="创建日期" min-width="100px"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="statusI18n" label="申请单状态" min-width="100px"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="roundNumber" label="报价轮次" min-width="100px"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="quotationStatusI18n" label="报价状态" min-width="100px"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="sourcingNo" label="报价确认申请单" min-width="140px">
          <template slot-scope="scope">
            <el-link @click.native="openSoucingInfo(item.sourcingNo)" style="display: block" :key="index" v-for="(item,index) in scope.row.sourcingList" type="primary">{{item.sourcingNo}}</el-link>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="sourcingStatus" label="报价确认状态" min-width="110px">
          <template slot-scope="scope">
            <el-link style="display: block" v-for="(item,index) in scope.row.sourcingList" :key="index" type="info">{{item.status}}</el-link>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination @size-change="pageSizeChange" @current-change="pageNumberChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount"></el-pagination>
      </div>

      <el-dialog :visible.sync="showSelSupplierDialog" append-to-body width="80%">
        <SelSupplier :multipleSelectionFlag="false" ref="supplierSelRef" v-if="SupplierNameDialogReset" @subCallMethod="selectSupplierMethod"></SelSupplier>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import {
  getProApplyList,
  delSelQuotationApply,
  closeApplyInfo
} from "@/api/quoteByProduct.js";
import { inputChoiceService } from "@/api/common/input-choice";
import commonFunction from "@/utils/dataTableUtils";
import SelSupplier from "@/components/page/base-data/carrier-sel-page";
import IcSelect from "@/components/common/icSelect";
import store from '@/store/index'
import paginationMixin from '../../../../mixins/pagitionMixin';
export default {
  name: "productQuotationApplication",
  mixins: [paginationMixin],
  components: {
    IcSelect,
    SelSupplier
  },
  data() {
    return {
      isShow: false,//控制查询列表收缩展开
      SupplierNameDialogReset: false,
      radioVal: null,
      selectRow: null,
      showSelSupplierDialog: false,
      eightLists: [],
      queryCondition: {
        pageSize: 15,
        pageNum: 1,
        applyNo: null,
        subject: null,
        applyType: null,
        supplierCode: null,
        status: null,
        quotationStatus: null,
        name: null,
        sourcingNo: null,
        sourcingStatus: null,
        createDate: null,
        createEndDate: null,
        tmSupplierId: null,
        eightBitCodesStr: null,
        eightBitCodes: [],
      },
      applyTypeOptions: [],
      statusListOptions: [],
      quotationStatusOptions: [],
      sourcingStatusOptions: [],
      tableData: [],
      totalCount: 0
    };
  },
  created() {
    // this.queryData(1);
    this.getInputChoiceValues();
  },
  watch: {
    queryCondition() {
      let _this = this;
      store.dispatch('uploadListParams', { routeName: _this.$route.name, reqData: _this.queryCondition })
    }
  },
  beforeRouteEnter(to, from, next) {
    const eightBitCodesStr = to.meta.reqData.eightBitCodesStr
    let eightBitCodesArr = []
    if (eightBitCodesStr && eightBitCodesStr.length > 0) {
      eightBitCodesArr = eightBitCodesStr.trim().split(/[\n,，; \s]+/g);
    }
    const requestData = Object.assign({}, to.meta.reqData)
    requestData.eightBitCodes = eightBitCodesArr
    getProApplyList(requestData).then((res) => {
      next(vm => {
        vm.queryCondition = requestData;
        vm.tableData = res.resultData;
        vm.totalCount = res.totalCount;
      })
    })
  },
  methods: {
    queryData(val) {
      let that = this;
      if (undefined != val) {
        this.queryCondition.pageNum = 1;
      }
      const eightBitCodesStr = this.queryCondition.eightBitCodesStr
      let eightBitCodesArr = []
      if (eightBitCodesStr && eightBitCodesStr.length > 0) {
        eightBitCodesArr = eightBitCodesStr.trim().split(/[\n,，; \s]+/g);
      }
      const requestData = Object.assign({}, this.queryCondition)
      this.$set(requestData, 'eightBitCodes', eightBitCodesArr)

      getProApplyList(requestData).then(res => {
        that.tableData = res.resultData;
        that.totalCount = res.totalCount;
      });
    },
    // onChangeClick(val) {
    //   console.log('8位码:', val);
    //   this.eightLists = []
    //   var arr = val.split(';')
    //   for (let i = 0; i < arr.length; i++) {
    //     this.eightLists.push({
    //       aaa: arr[i]
    //     })
    //   }
    // },
    getInputChoiceValues() {
      let mapObj = {};
      mapObj["TT_QUOTATION_APPLY:STATUS"] = "TT_QUOTATION_APPLY:STATUS";
      mapObj["TT_QUOTATION:STATUS"] = "TT_QUOTATION:STATUS";
      mapObj["TT_SOURCING:STATUS"] = "TT_SOURCING:STATUS";
      mapObj["TT_QUOTATION_APPLY:PRODUCT_APPLY_TYPE"] =
        "TT_QUOTATION_APPLY:PRODUCT_APPLY_TYPE";
      mapObj["TT_QUOTATION_APPLY:APPLY_TYPE"] = "TT_QUOTATION_APPLY:APPLY_TYPE";
      inputChoiceService.getInputChoiceValues(mapObj).then(res => {
        this.applyTypeOptions = res["TT_QUOTATION_APPLY:PRODUCT_APPLY_TYPE"];
        this.statusListOptions = res["TT_QUOTATION_APPLY:STATUS"];
        this.quotationStatusOptions = res["TT_QUOTATION:STATUS"];
        this.sourcingStatusOptions = res["TT_SOURCING:STATUS"];
      });
    },
    addNewApply(id) {
      this.$router.push({
        path: `/product-quotation-application-add`,
        query: { applyId: id }
      });
    },
    openQuotationApplyDetail: function (row) {
      this.$router.push({
        path: `/product-quotation-application-add`,
        query: {
          applyId: row.ttQuotationApplyId,
          source: "apply",
          applyType: row.applyType
        }
      });
    },
    //单选操作
    getSelectRow(row) {
      this.selectRow = [];
      this.selectRow = row;
    },
    selectSupplierMethod: function (supList) {
      this.queryCondition.supplierCode = supList[0].supplierName;
      this.queryCondition.tmSupplierId = supList[0].tmSupplierId;
      this.showSelSupplierDialog = false;
    },
    clearSupplierName() {
      this.queryCondition.supplierName = "";
      this.queryCondition.tmSupplierId = null;
      this.SupplierNameDialogReset = false
      this.$nextTick(() => {
        this.SupplierNameDialogReset = true
      })
    },
    delApply() {
      let that = this;
      if (this.selectRow == null) {
        //请选择需要删除的申请单
        that.$message({
          message: this.$t("apply.selectDelApply"),
          type: "warning"
        });
      } else {
        let delId = that.selectRow.ttQuotationApplyId;
        let ownerFlag = this.selectRow.ownerFlag;
        let source = this.selectRow.source;
        //只能删除自己的单据，供应商创建的也不可以删除
        if (!ownerFlag || (ownerFlag && source == "SUP")) {
          that.$message({ message: "只能操作自己名下的单据", type: "warning" });
          return;
        }
        //判断单据是否为草稿状态
        if (that.selectRow.status != "1") {
          //只有草稿状态的申请单才可以删除
          that.$message({
            message: this.$t("apply.delApplyParam"),
            type: "warning"
          });
          return;
        }
        // //请确认是否删除!
        that
          .$confirm(that.$t("common.delConfirm"), that.$t("common.tips"), {
            confirmButtonText: that.$t("common.confirm"),
            cancelButtonText: that.$t("common.cancel"),
            type: "warning"
          })
          .then(() => {
            delSelQuotationApply(delId).then(res => {
              if (res.meta.success) {
                that.selectRow = null;
                that.radioVal = null;
                that.$message({
                  message: that.$t("common.delSuccess"),
                  type: "success"
                });
                that.queryData();
              } else {
                that.$message({
                  message: that.$t("common.delError"),
                  type: "error"
                });
              }
            });
          })
          .catch(() => { });
      }
    },
    closeApply() {
      var that = this;
      if (this.selectRow == null) {
        //请选择需要作废的申请单!
        that.$message({
          message: this.$t("apply.selectCloseApply"),
          type: "warning"
        });
      } else {
        let delId = this.selectRow.ttQuotationApplyId;
        let ownerFlag = this.selectRow.ownerFlag;
        if (!ownerFlag) {
          that.$message({ message: "只能操作自己名下的单据", type: "warning" });
          return;
        }
        //请确认是否关闭
        this.$confirm(this.$t("common.closeConfirm"), this.$t("common.tips"), {
          confirmButtonText: this.$t("common.confirm"),
          cancelButtonText: this.$t("common.cancel"),
          type: "warning"
        })
          .then(() => {
            closeApplyInfo(delId).then(res => {
              if (res.meta.success) {
                this.selectRow = null;
                this.radioVal = null;
                that.$message({
                  message: this.$t("common.closeSuccess"),
                  type: "success"
                });
                this.queryData();
              } else {
                that.$message({
                  message: this.$t("common.closeError"),
                  type: "error"
                });
              }
            });
          })
          .catch(() => { });
      }
    },
    restQueryFormThis() {
      this.$refs.queryCondition.resetFields();
      this.queryCondition = {
        pageSize: 15,
        pageNum: 1,
        applyNo: null,
        subject: null,
        applyType: null,
        supplierCode: null,
        status: null,
        quotationStatus: null,
        name: null,
        sourcingNo: null,
        sourcingStatus: null,
        createDate: null,
        createEndDate: null,
        tmSupplierId: null,
        eightBitCodesStr: null,
        eightBitCodes: [],
      }
      this.selectRow = null;
      this.radioVal = ''
      this.queryData();
    },
    openSoucingInfo: function (no) {
      if (this.actionCheck.actionCheck("Sourcing-productDetail") === false) {
        this.$message.error(this.$t("common.noPermission"));
        return false;
      }
      this.$router.push({
        path: `/sourcingByProduct-detail`,
        query: {
          sourcingNo: no
        }
      });
    }
  },
  extends: commonFunction
};
</script>
<style scoped lang="scss">
.productQuotationApplication {
  .toolsBox {
    margin-bottom: 10px;
  }
  .a-link {
    text-decoration: underline;
  }
  .el-input {
    width: 100%;
  }
  .el-select {
    width: 100%;
  }
  .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: 100%;
  }
}
</style>
